module.exports = __webpack_public_path__ + "static/media/FacebookRound.4d887129.svg";